import { render } from "./one-tab-with-image-block.vue?vue&type=template&id=0d3a0e23"
import script from "./one-tab-with-image-block.vue?vue&type=script&lang=js"
export * from "./one-tab-with-image-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__